import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { ChevronDownIcon } from 'lucide-react';
import { Reveal } from './Reveal';
type FAQItem = {
  question: string;
  answer: string;
};
const faqs: FAQItem[] = [{
  question: 'Do I need prior knowledge of energy healing to use this system?',
  answer: 'No. Each volume is written as a complete standalone reference guide — fully accessible to beginners and deeply valuable for advanced practitioners. You can open any volume at any level and find exactly what you need.'
}, {
  question: 'What format do I receive the files in?',
  answer: 'All 6 volumes and 5 bonus guides are delivered as high-quality PDF files. You can read them on any device — phone, tablet, or computer — or print them at home in standard A4 or US Letter format.'
}, {
  question: 'Are the resources really printable?',
  answer: 'Yes. Every chart, map, log, and reference sheet is designed for home printing in standard formats. Many practitioners print and laminate their correspondence charts for permanent use in their therapy rooms and sessions.'
}, {
  question: 'Are all 5 bonus guides really FREE?',
  answer: 'Yes. All 5 bonus guides are included at no additional cost when you purchase today. This is a launch offer available for a limited time — it will not last indefinitely and the price will increase.'
}, {
  question: 'How long do I have access?',
  answer: 'Lifetime access. Once you purchase, all files are yours forever. Download them immediately after purchase and store them on any device, cloud drive, or computer you choose.'
}, {
  question: 'What makes this different from free resources online?',
  answer: 'Free online resources are fragmented, inconsistent, and unstructured. This system consolidates everything into one professionally designed reference library — organized so that all 6 disciplines connect and reinforce each other in one coherent framework.'
}, {
  question: 'What if it doesn’t work for me?',
  answer: 'If within 7 days you are not completely satisfied, contact us for a full refund. No forms, no questions, no hassle. The risk is entirely ours. Our real refund rate is less than 1%.'
}];
function Item({
  item,
  index
}: {
  item: FAQItem;
  index: number;
}) {
  const [open, setOpen] = useState(false);
  return <Reveal delay={index * 0.035} data-id="element-63" data-mp="2aysaycutxllh">
      <div className="overflow-hidden rounded-2xl border border-navy/10 bg-white shadow-premium" data-id="element-64" data-mp="2avnxspzdzfio">
        <button className="flex w-full items-center gap-4 p-5 text-left sm:p-6" onClick={() => setOpen(!open)} aria-expanded={open} data-id="element-65" data-mp="38jev4pyj9bdp">
          <span className="flex h-7 w-7 shrink-0 items-center justify-center rounded-full bg-sage text-sm font-bold text-white" data-id="element-66" data-mp="2yn1sh2l0fn6t">
            ?
          </span>
          <span className="flex-1 font-semibold text-navy" data-id="element-67" data-mp="2ulgknvnc1z3h">{item.question}</span>
          <ChevronDownIcon className={`h-5 w-5 shrink-0 text-sage transition-transform ${open ? 'rotate-180' : ''}`} data-id="element-68" data-mp="1n8y1845t4d5g" />
        </button>
        <AnimatePresence initial={false} data-id="element-69" data-mp="1j8xja9ji1jtn">
          {open && <motion.div initial={{
          height: 0,
          opacity: 0
        }} animate={{
          height: 'auto',
          opacity: 1
        }} exit={{
          height: 0,
          opacity: 0
        }} transition={{
          duration: 0.22
        }} data-id="element-70" data-mp="3uuy0wkkxcvrt">
              <p className="px-5 pb-6 pl-16 text-sm leading-7 text-slate sm:px-6 sm:pl-[4.5rem]" data-id="element-71" data-mp="cfnje1madul4">
                {item.answer}
              </p>
            </motion.div>}
        </AnimatePresence>
      </div>
    </Reveal>;
}
export function FAQ() {
  return <section className="w-full bg-mist px-4 py-20 sm:py-24" data-id="element-72" data-mp="mcjumf3kkutd">
      <div className="mx-auto max-w-3xl" data-id="element-73" data-mp="qfgf6bco70zy">
        <Reveal className="text-center" data-id="element-74" data-mp="qghpgdlv3jgm">
          <h2 className="font-serif text-4xl text-navy sm:text-5xl" data-id="element-75" data-mp="vejctaqbm4xw">
            ❓ Frequently Asked <span className="text-sage" data-id="element-76" data-mp="2s7313yhpg5pk">Questions</span>
          </h2>
          <p className="mt-5 text-slate" data-id="element-77" data-mp="2s8w9bi7yuxzo">Everything you need to know before you buy.</p>
        </Reveal>
        <div className="mt-10 space-y-3" data-id="element-78" data-mp="2x88ttwbd7sz3">
          {faqs.map((faq, index) => <Item key={faq.question} item={faq} index={index} data-id="element-79" data-mp="21uoesyjr4fwm" data-mpi={index} />)}
        </div>
      </div>
    </section>;
}